import { useNavigate } from "react-router-dom";
import { useAuth } from "../Hooks/AuthContext";
import { useEffect, useState } from "react";
import { unAuthGet } from "../Services/api.service";
import { Paths } from "../Services/EndPoints";
import { Badge, Button } from "@nextui-org/react";
import { useSelector } from "react-redux";

/* Design store-header cart — Feather outline shopping-cart, 20px, ink-900. */
function CartIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-5 h-5 text-ink-900"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" />
    </svg>
  );
}

export const CartQuantity = ({ isInvisible }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [value, setValue] = useState(0);
  const cartQuantity = useSelector((state) => state.cartQuantity);

  const fetchCartQuantity = () => {
    unAuthGet(Paths?.get_cart_count)
      .then((res) => {
        setValue(res?.data);
      })
      .catch((err) => console.log(err));
    // .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchCartQuantity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartQuantity]);

  useEffect(() => {
    if (!user) {
      setValue(0);
    }
  }, [user]);
  return (
    <Button
      isIconOnly
      variant="light"
      color="#000"
      onClick={() => navigate("/cart")}
      className="bg-transparent w-full h-full min-w-0 p-0"
    >
      <Badge
        size="md"
        content={value || 0}
        color="primary"
        isInvisible={value === 0}
      >
        <CartIcon />
      </Badge>
    </Button>
  );
};
